import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class COEBidsDetailsByDateReportService {
  constructor(private http: HttpUtilService) {}

  COEBidsDetailsByDateReport(model: {
    BidFor: string;
    StockAt: string;
    Type: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/COEBidsDetailsByDateReport`,
      {
        model: model,
      },
    );
  }
}
